import ApiBase from './api-base'
import omitBy from 'lodash/omitBy'
import isNil from 'lodash/isNil'
import { notifyBugsnag } from '@/modules/services/bugsnag'
class Kameleoon extends ApiBase {
  constructor () {
    super()

    this.url = '/api/web/v1/kameleoon'
    this.headers = { 'x-swa': true }
  }

  async trackEvent (params) {
    const url = `${this.url}/track`

    try {
      const filteredParams = omitBy(params, isNil)

      filteredParams.metadata = Object.entries(
        filteredParams.metadata || {}
      ).reduce((acc, [key, value]) => {
        if (key) acc[key.toUpperCase()] = value
        return acc
      }, {})

      return await this.client.post(url, filteredParams, {
        headers: this.headers
      })
    } catch (error) {
      notifyBugsnag(error)
      return { success: false }
    }
  }
}

export default Kameleoon
